<template>
 <v-container fluid>
   <v-card flat>
    <v-toolbar
      color="grey darken-4"
      dark
      extended
      flat
    >
      <!--<v-app-bar-nav-icon></v-app-bar-nav-icon>-->
    </v-toolbar>

    <v-card
      class="mx-auto"
      max-width="1100"
      style="margin-top: -64px;"
      :loading="loading"
      v-if="companie"
    >
      <v-toolbar flat>
        <v-toolbar-title class="black--text">Mi Comercio</v-toolbar-title>

        <v-spacer></v-spacer>
        
        <!--<v-btn v-if="companie" :to="`/me/${companie.attributes.slug ? companie.attributes.slug : companie.id}`" color="black" class="white--text">
          <v-icon class="mr-1">mdi-open-in-new</v-icon>
          Ver Perfil público
        </v-btn>-->

        <!--<v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>-->
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>

          <v-card
            class="mx-auto mb-5"
            max-width="100%"
            outlined
        >
            <v-list-item three-line>
            <v-list-item-content>
                <div class="overline mb-2">
                <v-chip
                    v-if="companie.attributes.status === 'active'"
                    :color="`success`"
                    class="ml-0"
                    text-color="white"
                    label
                    small
                >
                    <v-avatar left>
                        <v-icon>mdi-lock-open-outline</v-icon>
                    </v-avatar>
                    ABIERTO
                </v-chip>

                <v-chip v-else text-color="black" class="ml-0" label small>
                     <v-avatar left>
                        <v-icon>mdi-lock-outline</v-icon>
                    </v-avatar>
                      CERRADO
                </v-chip>
                </div>

                <v-list-item-title class="headline mb-1">{{ companie.attributes.name }} </v-list-item-title>
                <v-list-item-subtitle class="mb-2"> 
                  <v-chip
                    class="text-center justify-center black--text"
                    :color="companie.attributes.plan.attributes.hexColor ? companie.attributes.plan.attributes.hexColor : 'success'"
                    small
                    outlined
                    v-if="companie.attributes.plan"
                  >
                    {{companie.attributes.plan.attributes.display_name}}
                  </v-chip>

                  <v-chip
                    class="text-center justify-center black--text"
                    small
                    outlined
                    v-else
                  >
                    No asignado
                  </v-chip>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="companie.attributes.plan" style="display: block;">{{ companie.attributes.plan.attributes.description }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar
                size="80"
                color="teal"
            >
                <v-img v-if="companie.attributes.logoUrl" :src="companie.attributes.logoUrl"></v-img>
                <span v-else class="white--text">FT</span>
            </v-list-item-avatar>
            </v-list-item>

            <v-card-actions>
            
            </v-card-actions>
        </v-card>


        <v-data-table
            :loading="loading_invoices"
            loading-text="Cargando... Por favor espere"
            :headers="headers"
            :items="invoices"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [50, 60, 70, 100, -1],
              'items-per-page-text': 'Items por página'
            }"
            :header-props="{
              sortByText: 'Ordenar por'
            }"
        >
            <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>FACTURAS</v-toolbar-title>
                <v-spacer></v-spacer>
                <!--<v-btn color="black" dark class="mb-2" @click="createBillingForStores()">Generar facturas</v-btn>-->
            </v-toolbar>
            </template>
            
            <template v-slot:item.attributes.logoUrl="{ item }">
              <v-avatar
                  size="36px"
                  color="teal"
                >
                  <img
                    v-if="item.attributes.logoUrl"
                    alt="Avatar"
                    :src="item.attributes.logoUrl"
                  >
                  <span v-else class="white--text">FT</span>
              </v-avatar>
            </template>

            <template v-slot:item.attributes.startDate="{ item }">
                {{$moment(item.attributes.startDate).format('ll')}}
            </template>

            <template v-slot:item.attributes.endDate="{ item }">
                {{$moment(item.attributes.endDate).format('ll')}}
            </template>

            <template v-slot:item.attributes.discount="{ item }">
                {{ !item.attributes.noDiscountApplies ? item.attributes.discount : 0 | currency }}
            </template>

            <template v-slot:item.attributes.subTotal="{ item }">
                {{ item.attributes.subTotal | currency }}
            </template>

            <template v-slot:item.attributes.total="{ item }">
                {{ item.attributes.total | currency }}
            </template>

            <template v-slot:item.attributes.status="{ item }">
                <v-chip
                    :color="item.attributes.status == 'paid' ? 'success' : 'warning' "
                    class="ml-0"
                    label
                    small
                >
                    {{ item.attributes.status == 'paid' ? 'PAGADA' : item.attributes.status == 'created' ? 'SIN PAGAR' : item.attributes.status.toUpperCase() }}
                </v-chip>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                color="blue"
                class="ma-1 white--text"
                @click="payInvoice(item)"
                small
                v-if="item.attributes.status !== 'paid'"
              >
                <v-icon left dark>mdi-cash-usd</v-icon>
                Pagar
              </v-btn>

              <v-btn
                color="secondary"
                class="ma-1 white--text"
                @click="goInvoice(item)"
                small
              >
                <v-icon left dark>mdi-file-chart</v-icon>
                Ver factura
              </v-btn>
           
            </template>
            <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Recargar</v-btn>
            </template>
        </v-data-table>

      </v-card-text>
    </v-card>
  </v-card>

  <!-- Dialogo cancel order -->
    <v-dialog
      v-model="dialogPdf"
      width="800"
      persistent
      scrollable
      eager
    >
      <v-card>
        <v-card-title
          class="title grey lighten-2"
          primary-title
        >
          <span class="text-capitalize"> Factura en PDF </span>
        </v-card-title>

        <v-card-text>
          <div class="mb-2"></div>
          <v-row align="center" justify="center">
            
            <v-col cols="12" class="">
               <iframe id="pdf" width="100%" height="500" :src="iframe" frameborder="0" allowfullscreen></iframe>
            </v-col>

          </v-row>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="dialogPdf = false"
          >
           <v-icon left>mdi-close</v-icon> Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- *End* Dialogo Send Push -->

  </v-container>
</template>

<script>
import Parse from 'parse'
import fs from 'fs'
import Helvetica from '!!raw-loader!pdfkit/js/data/Helvetica.afm'
// use raw-loader explicitly
import Courier from '!!raw-loader!pdfkit/js/data/Courier.afm'
// use raw-loader implicitly (webpack is configured to load *.afm files using raw loader)
import CourierBold from 'pdfkit/js/data/Courier-Bold.afm'
//eslint-disable-next-line
var ace = require('brace');
require('brace/mode/javascript');
require('brace/theme/monokai');

export default {
    data() {
        return {
            companie: {
                attributes: {
                name: '',
                city: '',
                phone: '',
                status: '',
                logoUrl: ''
              }
            },
            loading: true,
            loading_invoices: true,
            search: '',
            headers: [
              //{ text: 'Comercio', align: 'left', value: 'attributes.store' },
              { text: 'Fecha de inicio', align: 'left', value: 'attributes.startDate' },
              { text: 'Fecha de corte', align: 'left', value: 'attributes.endDate' },
              { text: 'Subtotal', align: 'left', value: 'attributes.subTotal' },
              { text: 'Descuento',align: 'left',  value: 'attributes.discount' },
              { text: 'Total', align: 'left', value: 'attributes.total' },
              //{ text: 'Método', align: 'left', value: 'attributes.payment' },
              { text: 'Estado', align: 'left', value: 'attributes.status' },
              { text: 'Acciones', align: 'left', value: 'action', sortable: false },
            ],
            invoices: [],
            invoice: {
                attributes: {
                    store: {},
                    discount: 0,
                    subTotal: 0,
                    total: 0,
                    payment: 0,
                    endDate: '',
                    startDate: '',
                    status: ''
                }
            },
           dialogPdf: false,
           iframe: ''
        }
    },

    async mounted() {
        await this.initialize();

        fs.writeFileSync('data/Helvetica.afm', Helvetica)
        fs.writeFileSync('data/Courier.afm', Courier)
        fs.writeFileSync('data/Courier-Bold.afm', CourierBold)
        this.registerBinaryFiles(require.context('../assets/festy', true))
    },

    methods: {
        async initialize(){
            
            const params = {
                id: this.$route.params.store_id
            }

            try {
            let companie = await Parse.Cloud.run("getMyStoreBO", params);
            this.companie = companie
            //eslint-disable-next-line
            //console.log(this.companie);
            this.loading = false

            this.getIncoives(this.companie)
            
            } catch (error) {
                this.$swal({
                    title: "Comercio",
                    text: "Algo salío mal consultado el comercio.",
                    icon: "warning",
                    buttons: ['Salir', 'Entiendo'],
                    dangerMode: true,
                    })
                    .then((ok) => {
                    if (ok) {
                        this.$router.push('/stores')
                    }else{
                        this.$router.push('/stores')
                    }
                });
            }
            
        },

        async getIncoives(store){
            const params = {
                id: store.id
            }

            try {
            let invoces = await Parse.Cloud.run("getMyInvocesBO", params);
            this.invoices = invoces
            //eslint-disable-next-line
            //console.log(this.invoices);
            this.loading_invoices = false
            
            } catch (error) {
                this.$snotify.error(`${error}` , 'Facturas', {
                    timeout: 4000,
                    preventDuplicates: true
                });
            }
        },

        generateInvocePdf(item){
            this.dialogPdf = true
            
            var PDFDocument = require('pdfkit').default;
            var blobStream = require('blob-stream');
            
            var doc = new PDFDocument();
            var stream = doc.pipe(blobStream());

           doc
            .image('logo-festy.PNG', 50, 45, { width: 70 })
            .fillColor("#444444")
            .fontSize(10)
            .text("Un festival de promociones todo el año!.", 200, 65, { align: "right" })
            .text("festtytech@gmail.com", 200, 80, { align: "right" })
            .moveDown();

            /**
            store
            discount
            subTotal
            total
            payment
            endDate
            startDate
            status
             */

            doc
            .text(`Factura ID: ${item.id}`, 50, 130)
            .text(`Total: ${this.$options.filters.currency(item.attributes.total)}`, 50, 200)
            .text(`Fecha: ${this.$moment(item.createdAt).format('lll')}`, 50, 215)
            .moveDown();

            // end and display the document in the iframe to the right
            var iframe = document.getElementById("pdf")

            doc.end();
            stream.on('finish', function() {
               iframe.src = stream.toBlobURL('application/pdf');
            });
        },

        registerBinaryFiles(ctx) {
            ctx.keys().forEach(key => {
                // extracts "./" from beginning of the key
                fs.writeFileSync(key.substring(2), ctx(key))
            });  
        },

        async payInvoice(invoice){

          //await invoice.fetch()
        
          const params = {
                id: invoice.id,
                store_id: this.companie.id
            }

            try {
            let invoce_fetch = await Parse.Cloud.run("getMyInvoceBO", params);
            invoice = invoce_fetch
            
            } catch (error) {
                this.$snotify.error(`${error}` , 'Facturas', {
                    timeout: 4000,
                    preventDuplicates: true
                });
            }

          if (!invoice.attributes.total || invoice.attributes.total < 7000) {
            this.$snotify.error(`El total de la factura debe ser mayor para pagos en linea.` , 'Facturas', {
              timeout: 4000,
              preventDuplicates: true
            });
            return;
          }

          if (invoice.attributes.status === 'paid') {
            this.$snotify.info(`Esta factura ya está pagada.` , 'Facturas', {
              timeout: 4000,
              preventDuplicates: true
            });
            return;
          }

          if (invoice.attributes.payment && invoice.attributes.payment.attributes.status == '1') {
            this.$snotify.info(`Esta factura ya tiene un pago asignado y aprobado.` , 'Facturas', {
              timeout: 4000,
              preventDuplicates: true
            });
            return;
          }

          //eslint-disable-next-line
          //console.log(invoice);
          
          //eslint-disable-next-line
          var handler = ePayco.checkout.configure({
            key: '36dcadb137adf6eea8c56e63cd254b27',
            test: false
          })

          var data = {
            //Parametros compra (obligatorio)
            name: `Pago Factura ${invoice.id} - ${this.$moment(invoice.attributes.endDate).format('MMMM').toUpperCase()} - ${this.$moment(invoice.attributes.endDate).format('YYYY')}`,
            description: `Pago de factura para el comercio ${invoice.attributes.store.attributes.name} de la ciudad de ${invoice.attributes.store.attributes.city.toUpperCase()}`,
            invoice: invoice.id,
            currency: "cop",
            amount: invoice.attributes.total,
            tax_base: "0",
            tax: "0",
            country: "co",
            lang: "es",

            //Onpage="false" - Standard="true"
            external: "false",

            //Atributos opcionales
            extra1: invoice.attributes.store.id,
            extra2: invoice.attributes.store.attributes.plan.id,
            extra3: invoice.attributes.store.attributes.owner.id,
            confirmation: process.env.VUE_APP_URL_CONFIRMATION_PAYCO,
            response: process.env.VUE_APP_URL_RESPONSE_PAYCO,

            //Atributos cliente
            /*name_billing: "Andres Perez",
            address_billing: "Carrera 19 numero 14 91",
            type_doc_billing: "cc",
            mobilephone_billing: "3050000000",
            number_doc_billing: "100000000",*/

            //atributo deshabilitación metodo de pago
            //methodsDisable: ["TDC", "PSE","SP","CASH","DP"]
          }

          //eslint-disable-next-line
          //console.log(data);

          handler.open(data)
        },

        goInvoice(invoice){
          this.$router.push('/invoice/' + invoice.id + '/' + invoice.attributes.store.id)
        },

    },
}
</script>